import React, { useEffect, useState } from "react"
import styles from "./SignUpPaywallPage.module.scss"
import PaywallContainer from "../../containers/PaywallContainer/PaywallContainer"
import PageLinedTitle from "../../components/elements/PageLinedTitle"
import ContentWithSidebars from "../../components/templates/ContentWithSidebars"
import { getPlanById } from "./utils/subscriptionConfig"
import { calculatePlan } from "./utils/planCalculator"
import { useLocation } from "react-router-dom"
import services from "../../services"

// Helper function to parse query parameters
const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const SignUpPaywallPage: React.FC = () => {
  const query = useQuery()
  const [loading, setLoading] = useState(false)
  const [application, setApplication] = useState<any>(null)

  // Get parameters from URL query string
  const params: Record<string, string> = {}
  query.forEach((value, key) => {
    params[key] = value
  })

  // Get the email from URL query string and decode it if it exists
  const email = params.email ? decodeURIComponent(params.email) : undefined

  // Get the code from URL query string if it exists
  const code = params.code || undefined

  // Get the plan ID from the URL query string
  const urlPlanId = params.plan

  // Fetch application by code if code exists
  useEffect(() => {
    const fetchApplication = async () => {
      if (code) {
        try {
          setLoading(true)
          const response = await services.userApplicationServices.getUserApplicationByCode(code)
          if (response?.data) {
            setApplication(response.data)
          }
        } catch (error) {
          console.error("Error fetching application by code:", error)
        } finally {
          setLoading(false)
        }
      }
    }

    fetchApplication()
  }, [code])

  // Determine final plan ID
  // Priority: URL param > calculated from application > default
  let finalPlanId = urlPlanId
  if (!finalPlanId && application) {
    const calculatedPlan = calculatePlan(application)
    if (calculatedPlan) {
      finalPlanId = calculatedPlan
    }
  }
  if (!finalPlanId) {
    finalPlanId = "national_corp" // Default fallback
  }

  // Get the subscription plan based on the plan ID
  const subscriptionPlan = getPlanById(finalPlanId)

  // Use email from application if available and not in URL
  const finalEmail = email || application?.email

  if (loading) {
    return (
      <div className={styles.pageWrap}>
        <PageLinedTitle title="B2T Subscription" />
        <ContentWithSidebars>
          <div>Loading...</div>
        </ContentWithSidebars>
      </div>
    )
  }

  return (
    <div className={styles.pageWrap}>
      <PageLinedTitle title="B2T Subscription" />

      <ContentWithSidebars>
        <PaywallContainer plan={subscriptionPlan} email={finalEmail} code={code} />
      </ContentWithSidebars>
    </div>
  )
}

export default SignUpPaywallPage
